import Link from '@/components/Link';
import Image from '@/components/Image';

export default function TrainingListingCard({
  uri,
  title,
  excerpt,
  details: { color, certification },
}) {
  const hasCertification = certification !== null;

  return (
    <Link
      className="transition ease-in-out duration-500 transform hover:-translate-y-1 rounded-lg lg:rounded-xl xl:rounded-2xl shadow-lg hover:shadow-outside-lg flex w-full ring-1 ring-black ring-opacity-10 hover:ring-opacity-20"
      href={uri}
    >
      <div className="flex flex-col rounded-lg lg:rounded-xl xl:rounded-2xl w-full">
        <div className="bg-white divide-y-2 divide-gray-100 rounded-t-lg lg:rounded-t-xl xl:rounded-t-2xl overflow-hidden flex-1 w-full relative">
          <div className="flex flex-col items-center text-center md:text-left md:flex-row space-y-6 md:space-y-0 md:space-x-6 px-6 lg:px-8 py-6">
            {hasCertification && (
              <Image
                src={certification.featuredImage.node.sourceUrl}
                alt={certification.title}
                width={150}
                height={150}
              />
            )}
            <div className="flex flex-col space-y-4 relative z-10 flex-1">
              <div className="flex flex-col space-y-2">
                <div className="font-semibold text-green-500">
                  Entrenamiento
                </div>
                <h3 className="text-2xl lg:text-3xl font-bold lg:font-medium tracking-tight text-gray-900 hover:text-gray-700">
                  <div className="leading-8 md:leading-9">{title}</div>
                </h3>
              </div>
              <div className="flex items-center justify-center md:justify-start">
                <span
                  className="inline-flex items-center space-x-1 leading-4 pl-5 pr-3 py-2 bg-green-500 text-white font-semibold rounded-full hover:bg-green-600 focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 focus:outline-none focus:bg-green-600"
                  tabIndex="-1"
                  role="button"
                >
                  <span>Conocer más</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div className="flex flex-col space-y-3 px-6 py-4 lg:py-8">
            <div
              className="text-gray-500 font-medium"
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
          </div>
        </div>
        <div
          className="flex items-center px-6 py-4 bg-green-500 rounded-b-lg lg:rounded-b-xl xl:rounded-b-2xl relative overflow-hidden"
          style={{ backgroundColor: color }}
        >
          <div className="flex-1 flex-col opacity-70 space-y-1 text-sm font-semibold text-white relative z-10">
            <div className="leading-none">Asociación</div>
            <div className="leading-none">Iberoamericana</div>
            <div className="leading-none">de Scrum</div>
          </div>
          <svg
            className="w-10 h-10 text-white relative z-10"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
          </svg>
          <div className="z-0 absolute inset-0 bg-gradient-to-tl from-black to-transparent opacity-20" />
        </div>
      </div>
    </Link>
  );
}
